
      
  <mat-toolbar>
    <span>User</span>
    <span class="fill-remaining-space"></span>
    <button class="btn-dialog-close" mat-stroked-button (click)="onClose()"><mat-icon>clear</mat-icon></button>
  </mat-toolbar>


<form [formGroup]="userForm"  autocomplete="off"  (ngSubmit)="saveButtonClick()" class="normal-form">
  <mat-grid-list cols="1" rowHeight="350px">
    <mat-grid-tile>
      <div class="row">
        <input readonly type="hidden" formControlName="id"> 
        <input readonly type="hidden" formControlName="empId">       
      </div>    
      <div class="controles-container">
        <mat-form-field>
          <input  formControlName="empName" [readonly]="isReadOnly" (focusout)="getEmployeeData()"   matInput  [matAutocomplete]="auto" placeholder="Employee Name">
          <mat-autocomplete autoActiveFirstOption  #auto="matAutocomplete">
            <mat-option *ngFor="let option of filteredOptions | async" [value]="option.EmpName">
              {{option.EmpName}}
            </mat-option>
          </mat-autocomplete>   
          <mat-error>This field is required</mat-error>
        </mat-form-field>
        <mat-form-field>
          <input formControlName="username" [readonly]="isReadOnly" matInput placeholder="User Name">
          <mat-error>This field is required</mat-error>
        </mat-form-field>
        <mat-form-field>
          <input type="password" [readonly]="isReadOnly" formControlName="password" matInput placeholder="Password">
          <mat-error>This field is required</mat-error>
        </mat-form-field>
        <mat-form-field>
          <mat-select  formControlName="userType" placeholder="User Type">
            <mat-option>None</mat-option> 
            <ng-container *ngFor="let item of userTypeList">
              <mat-option  [value]="item.UserType">
                {{item.UserType}}
              </mat-option>
            </ng-container>                  
          </mat-select>
          <mat-error>This field is required</mat-error>
        </mat-form-field> 
        <div class="add-bottom-padding">
          <mat-checkbox formControlName="status">Deactivated</mat-checkbox>
        </div>

        <div class="button-row">
            <button mat-raised-button color="primary" type="submit">
              <span *ngIf ="showProcessingIndicator" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
              Save
            </button> 

            <button type="button" mat-raised-button color="warn" (click)="newButtonClick()">Clear</button>
          </div>
      </div>
    </mat-grid-tile>
  </mat-grid-list>
</form>

<!-- Form Values : {{ userForm.value | json }}  -->